import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';

import { RffInput } from '@cast/shared-rff-ui';

export const NodeNameSection = () => {
  return (
    <InlineWithDescription
      description={
        <ControlWithDescription label="Name">
          Name of the provisioned edge node.
        </ControlWithDescription>
      }
      controls={
        <RffInput
          name="name"
          label="Name"
          placeholder="e.g. edge-node-1"
          testId="node-name-input"
        />
      }
    />
  );
};
